// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#about {
    padding: 10rem 1rem;
    background-color: #f8f8f8;
    /* padding: 50px 0; */
  }
  
  .about-content {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }
  
  .section-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .section-description {
    font-size: 12px;
    line-height: 1.5;
    color: #555;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/About.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb","sourcesContent":["#about {\n    padding: 10rem 1rem;\n    background-color: #f8f8f8;\n    /* padding: 50px 0; */\n  }\n  \n  .about-content {\n    max-width: 800px;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .section-title {\n    font-size: 36px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n  \n  .section-description {\n    font-size: 12px;\n    line-height: 1.5;\n    color: #555;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
